import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsHeroImageClickedParams = {
  trail_id: number;
};

/**
 * User clicks on the hero image (first picture) from the trail details page
 * @param params - Attributes to log with the amplitude event
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsHeroImageClicked = ({ trail_id }: logTrailDetailsHeroImageClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details hero image clicked', { 'trail id': trail_id }, callback);
};

export default logTrailDetailsHeroImageClicked;
